export default __webpack_public_path__ + "static/media/arrowToBottom.b0ab3cd8.svg";